export enum GrupaKvizPitanja {
	Istorija = 1,
	Geografija = 2,
	Fizika = 3,
	Hemija = 4,
	Matematika = 5,
	Biologija = 6,
	'Likovna umetnost' = 7,
	Muzika = 8,
	Književnost = 9,
	'Film i pozorište' = 10,
	Sport = 11,
	Biznis = 12,
	'Politika i pravo' = 13,
	Hobi = 14,
	Putovanja = 15,
	Opšte = 16,
	Kulinarstvo = 17,
	Geologija = 18,
	Saobraćaj = 19,
	Ugostiteljstvo = 20,
	Građevinarstvo = 21,
}
